export default class DuplicatePat extends Error {
    constructor() {
        super("PAT already exists!");
    }
}
